import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const TasksModelSchema = z
  .object({
    id: z.string(),
    notes: z.string().nullish(),
    due_by: z.string().nullish(),
    subject: z.string().nullish(),
    completed: z.boolean().nullish(),
    sort_order: z.number().nullish(),
    created_at: z.string().nullish(),
    completed_on: z.string().nullish()
  })
  .strict()

export const TasksModelFields = makeFieldKeys(TasksModelSchema)

export type TasksModel = z.infer<typeof TasksModelSchema>

function validateTasksModel(data: unknown): TasksModel {
  try {
    return validateWithZodSchema(TasksModelSchema, data, 'tasks model')
  } catch (error) {
    throw new Error(`Tasks model validation failed: ${error}`)
  }
}
